import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderTaskPayloadStatusChanged(props: TypicalMessageProps) {
    const details = props.model.message_details;
    if (details['@type'] !== 'order-task.change-status.status-changed' || !('target' in details)) {
        return <TypicalMessage model={props.model} options={props.options}/>;
    }

    return <TypicalMessage
            model={props.model}
            options={props.options}
            messageKeysWithStatusId={['was', 'became']}
            choice={details.target === 'order' ? 1 : 2}
            optionsKey={details.target === 'order' ? 'status' : 'productStatuses'}
    />;
}
